import React from 'react';
import { Input } from './input';
import { Label } from './label';
import { Minus } from 'lucide-react';

interface RangeFilterProps {
  label: string;
  minValue: string;
  maxValue: string;
  onMinChange: (value: string) => void;
  onMaxChange: (value: string) => void;
  placeholder?: string;
  unit?: string;
  className?: string;
}

export const RangeFilter: React.FC<RangeFilterProps> = ({
  label,
  minValue,
  maxValue,
  onMinChange,
  onMaxChange,
  placeholder = "Enter value",
  unit,
  className
}) => {
  return (
    <div className={`space-y-2 ${className}`}>
      <Label className="text-sm font-medium text-gray-700">
        {label}
      </Label>
      <div className="flex items-center gap-2">
        <div className="flex-1">
          <Input
            placeholder={`Min ${placeholder}`}
            value={minValue}
            onChange={(e) => onMinChange(e.target.value)}
            className="w-full"
            type="number"
          />
          {unit && <span className="text-xs text-gray-500 ml-1">{unit}</span>}
        </div>
        <Minus className="h-4 w-4 text-gray-400 flex-shrink-0" />
        <div className="flex-1">
          <Input
            placeholder={`Max ${placeholder}`}
            value={maxValue}
            onChange={(e) => onMaxChange(e.target.value)}
            className="w-full"
            type="number"
          />
          {unit && <span className="text-xs text-gray-500 ml-1">{unit}</span>}
        </div>
      </div>
    </div>
  );
}; 